// extracted by mini-css-extract-plugin
export default {"root":"diamondSizeSlider_root__AhkGI"};